<div *ngIf="data" class="customers-summary mb-2 clearfix">
  <h4 class="float-start">{{'entity.customers'|translate}}</h4>
  <div class="summary horizontal float-end mt-1 clearfix">
    <div class="data-column">
      <div class="title me-2">Totaal klanten:</div>
      <div class="value">{{data.customerCount}}</div>
    </div>
    <div class="data-column">
      <div class="title me-2">Lopende {{'entity.projects'|translate|lowercase}}:</div>
      <div class="value">{{data.runningProjectCount}}</div>
    </div>
    <div class="data-column">
      <div class="title me-2">{{'entity.blocked'|translate}} klanten:</div>
      <div class="value">{{data.blockedCustomerCount}}</div>
    </div>
  </div>
</div>
